import React from "react";
import { FormattedNumberCell } from "../../../Utils/helpers/formatting";
import ArrowInsights from "../../../Components/Tables/arrow-insights";

const PaidAndProductAdsPerformance = (props) => {
  const blockId = props?.extraParams?.block?.block_id;
  const cellClass = "";

  if (blockId == 889) {
    if (props?.column.title == "Change") {
      return (
        <div style={{ display: "flex" }}>
          <ArrowInsights value={props.value} metric={props.column.dataIndex} />
          <span className={cellClass}>
            <FormattedNumberCell
              value={props.value}
              format={props.column.format}
              metric={props.column.dataIndex}
            />
          </span>
        </div>
      );
    }
  }

  return (
    <span className={cellClass}>
      <FormattedNumberCell
        value={props.value}
        format={props.column.format}
        metric={props.column.dataIndex}
      />
    </span>
  );
};

export default PaidAndProductAdsPerformance;
